import type { FunctionComponent } from 'react';

import { FormattedMessage } from '../../../shared/components/formatted-message/formatted-message';
import { Gap } from '../../../shared/components/gap/gap';
import { Icon, IconSize } from '../../../shared/components/icon/icon';
import { createStyleHelper } from '../../../shared/utils/class-names';
import { slugify } from '../../../shared/utils/strings';

import styles from './error.module.scss';

const style = createStyleHelper(styles, 'receipt');

export interface IErrorProps {
    transactionId: string;
    error: string;
}

export const Error: FunctionComponent<IErrorProps> = ({ transactionId, error }) => {
    return (
        <div className={style()}>
            <Gap>
                <div className={style('icon')}>
                    <Icon name={'times-circle'} size={IconSize.AUTO} />
                </div>
                <p className={style('message')}>
                    <FormattedMessage
                        id="cashier.error.message"
                        defaultMessage={
                            'An error occurred while processing this transaction. <br></br>Please see below for more information. You can get in contact with our support team to find out more information. <br></br>Transaction id: {transactionId}'
                        }
                        values={{
                            transactionId,
                        }}
                    />
                </p>
                <p className={style('error')}>
                    <FormattedMessage
                        id={`cashier.error.${slugify(error)}`}
                        defaultMessage={error}
                        values={{
                            error,
                        }}
                    />
                </p>
            </Gap>
        </div>
    );
};
